import { useEffect, useState } from 'react';
import { SuperAdminSidebar } from '../../components/Sidebar';
import api from '../../utils/api';

export default function Backups() {
  const [backups, setBackups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);

  const load = () => {
    setLoading(true);
    api.get('/superadmin/backups')
      .then((r) => setBackups(r.data.backups || []))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const createNow = async () => {
    setCreating(true);
    try { await api.post('/superadmin/backups'); setTimeout(load, 1500); }
    catch { alert('Backup fehlgeschlagen'); }
    finally { setTimeout(() => setCreating(false), 1600); }
  };

  const download = async (name) => {
    try {
      const r = await api.get(`/superadmin/backups/${name}/download`, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 1500);
    } catch { alert('Download fehlgeschlagen'); }
  };

  const fmtSize = (b) => (b > 1e6 ? (b / 1e6).toFixed(1) + ' MB' : (b / 1e3).toFixed(0) + ' KB');
  const fmtDate = (d) => new Date(d).toLocaleString('de-CH');

  return (
    <div style={{ display: 'flex' }}>
      <SuperAdminSidebar />
      <main className="main-content">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, gap: 12, flexWrap: 'wrap' }}>
          <h1 style={{ fontSize: 28, margin: 0 }}>Datenbank-Backups</h1>
          <button className="btn btn-primary" onClick={createNow} disabled={creating}>
            {creating ? 'Wird erstellt…' : 'Backup jetzt erstellen'}
          </button>
        </div>
        <p style={{ color: 'var(--text3)', marginBottom: 24, fontSize: 14 }}>
          Tägliche automatische Backups (03:30 Uhr, 14 Tage Aufbewahrung). Bitte regelmäßig herunterladen und extern aufbewahren.
        </p>
        <div className="card">
          {loading ? (
            <div className="spinner-wrap"><div className="spinner" /></div>
          ) : backups.length === 0 ? (
            <p style={{ color: 'var(--text3)', textAlign: 'center', padding: 32 }}>Keine Backups vorhanden.</p>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr><th>Datei</th><th>Größe</th><th>Erstellt</th><th></th></tr>
                </thead>
                <tbody>
                  {backups.map((b) => (
                    <tr key={b.name}>
                      <td style={{ fontFamily: 'monospace', fontSize: 13 }}>{b.name}</td>
                      <td style={{ color: 'var(--text2)' }}>{fmtSize(b.size)}</td>
                      <td style={{ color: 'var(--text3)', fontSize: 13 }}>{fmtDate(b.mtime)}</td>
                      <td style={{ textAlign: 'right' }}>
                        <button className="btn btn-secondary btn-sm" onClick={() => download(b.name)}>Herunterladen</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
